import React, { Component } from "react";
import "./products.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import { Link, useParams } from "react-router-dom";

import { getProductById } from "../../constants/products-constant";

function ProductDetail() {
    const params = useParams();
    const product = [...getProductById(params.id)][0];


    return (
        <Page>
            <Header />
            <section className="container productdetail_top">
                <div className="row ">
                    <figure className="figure">
                        <img src={`${product.imageSquareAddress}`} className="figure-img img-fluid centerimg" alt="..." />
                        <figcaption className="figure-caption">
                            <span>دسته بندی محصول</span>
                            <h2>
                                {product.title}
                            </h2>
                        </figcaption>
                    </figure>
                    <span className="col parameter">
                        <b> {product.detailTitle1}</b><br />
                        {product.detailDescription1}
                    </span>
                    <span className="col parameter">
                        <b> {product.detailTitle2}</b><br />
                        {product.detailDescription2}
                    </span>
                    <span className="col parameter">
                        <b> {product.detailTitle3}</b><br />
                        {product.detailDescription3}
                    </span>
                    <p className="text-body mt-4">
                        {product.descriptoin}
                    </p>
                </div>
            </section>

            <section className="container">
                <div className="row hrow">
                    <h4 className="ha_title">
                        {product.briefTitle}
                    </h4>
                    <p className="hy-text-body">
                        {product.briefDescription}
                    </p>
                </div>
                <div className="row hrow">
                    <h4 className="ha_title">
                        {product.secondBriefTitle}
                    </h4>
                    <p className="hy-text-body">
                        {product.secondBriefDescription}
                    </p>
                </div>
            </section>
            {product.isHasCatalog === "true" && (
                <section className="container ">
                    <div className="row hrow gray_container">
                        <h5>دریافت کاتالوگ فنی</h5>
                        <p>این کاتالوگ شامل مشخصات فنی، اندازه ها، دوره های بازرسی و هر آنچه باید در مورد این محصول بدانید می باشد و میتوانید از لینک دانلود دریافت کنید.</p>
                        <a className="btn btn-dark" target="_blank" href={`${product.catalogUrl}`} download>دریافت کاتالوگ</a>
                    </div>
                </section>
            )}
            {product.isHasDataSheet === "true" && (
                <section className="container ">
                    <div className="row hrow gray_container">
                        <h5>دریافت دیتا شیت</h5>
                        <p>این دیتا شیت شامل دیتیل اطلاعاتی است که باید در مورد این محصول بدانید می باشد و میتوانید از لینک دانلود دریافت کنید.</p>
                        <a className="btn btn-dark" target="_blank" href={`${product.dataSheetUrl}`} download>دریافت دیتاشیت</a>
                    </div>
                </section>
            )}
            <section className="container">
                <div className="row hrow mt-4">
                    <Link className="btn btn-dark" to="/consuling"> درخواست  کارشناس مشاور</Link>
                </div>
            </section>
            <Footer />
        </Page>
    );
}
export default ProductDetail;